export type OrderEditProductType = 'add' | 'edit' | 'delete';

export type OrderDiscountType =
  | 'promotional_discount'
  | 'coupon_discount'
  | 'shipping_discount'
  | 'gateway_discount';

export const PROMOTIONAL_DISCOUNT: OrderDiscountType = 'promotional_discount';
export const COUPON_DISCOUNT: OrderDiscountType = 'coupon_discount';
export const SHIPPING_DISCOUNT: OrderDiscountType = 'shipping_discount';
export const GATEWAY_DISCOUNT: OrderDiscountType = 'gateway_discount';

export type OrderEditDiscountType = 'add' | 'remove' | 'replace';

export interface OrderEditProduct {
  id?: string;
  productId: string;
  variantId: string;
  variants: string;
  title: string;
  quantity: number;
  price: number;
  totalPrice: number;
  sku: string | null;
  photoUrl: string;
  properties?: Record<string, string>;
  editType?: OrderEditProductType;
  originalQuantity?: number;
  maxStock?: number | null;
  restoreStock?: boolean;
  fulfillmentOrderId?: string;
  locationId?: string;
}

export interface OrderEditDiscount {
  id: string;
  name: string;
  value: number;
  discountType: OrderDiscountType;
  editType?: OrderEditDiscountType;
  removed: boolean;
  prefix?: string;
  appearance?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'light';
}
